import { Routes } from '@angular/router';
import { AdminGuard } from '../guards/admin/admin.guard';
import { Role } from '../interface/roles/roles.interface';
import { ImportWizardService } from 'src/app/pages/project/map/repository/import-wizard/import-wizard.service';
import { ImportWizardResolver } from 'src/app/resolvers/shared-import-wizard/shared-import-wizard.resolver';
import { SharedImportLinkGuard } from 'src/app/guards/shared-import/shared-import-link.guard';
import { SharedImportsService } from 'src/app/pages/shared-imports/shared-imports.service';
import { ImportWizardGeospatialMinimapService } from '../pages/project/map/repository/import-wizard/components/geospatial/_components/minimap/import-wizard-geospatial-minimap.service';
import { ImportJobGuard } from '../guards/import-job/import-job.guard';

export const SHARED_IMPORT_WIZARD_ROUTES: Routes = [
  {
    path: 'shared/import/:shared_import_id',
    children: [
      {
        path: 'invalid-link',
        loadComponent: () =>
          import('../pages/shared-imports/shared-imports-invalid-link/shared-imports-invalid-link.component')
            .then(m => m.SharedImportsInvalidLinkComponent)
      },
      {
        path: '',
        loadComponent: () =>
          import('../pages/shared-imports/shared-imports.component')
            .then(m => m.SharedImportsComponent),
        canActivate: [AdminGuard, SharedImportLinkGuard],
        providers: [SharedImportsService],
        data: {
          roles: [
            Role.MASTER,
            Role.SUPERUSER,
            Role.EDITAR_PROJETO,
            Role.EDITAR_REPOSITORIO,
            Role.FORESTOKEN
          ]
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/shared-imports/shared-imports-hub/shared-imports-hub.component')
                .then(m => m.SharedImportsHubComponent)
          },
          {
            path: 'job/:import_wizard_id',
            providers: [ImportWizardResolver, ImportWizardService, ImportWizardGeospatialMinimapService],
            canActivate: [ImportJobGuard],
            resolve: {
              importWizard: ImportWizardResolver
            },
            children: [
              {
                path: 'geospatial',
                loadComponent: () =>
                  import('../pages/project/map/repository/import-wizard/components/geospatial/import-wizard-geospatial.component')
                    .then(m => m.ImportWizardGeospatialComponent)
              },
              {
                path: 'tabular',
                loadComponent: () =>
                  import('../pages/project/map/repository/import-wizard/components/tabular/import-wizard-tabular.component')
                    .then(m => m.ImportWizardTabularComponent)
              }
            ]
          }
        ]
      }
    ]
  }
];